import io from "socket.io-client";
import store from "@/store";
import { router } from "@/router";

let baseURL = "http://localhost:3000";
if (process.env.NODE_ENV === "production") {
  baseURL = "https://geskitchenrealtimeservice.com";
}

let socket = undefined;

let getters = {
  transactions: undefined,
  integratedTransactions: undefined,
  recipes: undefined,
  products: undefined
};

function connect() {
  socket = io(baseURL, {
    query: {
      store: store.getters.getStoreId,
      organisation: store.getters.getOrganisationId
    }
  });

  socket.on("connect", () => {
    store.commit("setSocketStatus", true);
  });

  socket.on("reconnect", () => {
    store.commit("setSocketStatus", true);
  });

  socket.on("disconnect", () => {
    if (store.getters.getSocketStatus !== false) {
      store.commit("setSocketStatus", false);
    }
  });

  socket.on("connect_error", () => {
    if (store.getters.getSocketStatus !== false) {
      store.commit("setSocketStatus", false);
    }
  });

  socket.on("reconnect_error", () => {
    if (store.getters.getSocketStatus !== false) {
      store.commit("setSocketStatus", false);
    }
  });

  socket.on("connect_timeout", () => {
    if (store.getters.getSocketStatus !== false) {
      store.commit("setSocketStatus", false);
    }
  });

  socket.on("transaction", () => {
    if (getters.transactions !== undefined) clearTimeout(getters.transactions);
    getters.transactions = setTimeout(() => {
      store.dispatch("loadInventoryRecords", { latest: true });
      getters.transactions = undefined;
    }, 2000);
  });

  socket.on("integratedTransaction", () => {
    if (getters.integratedTransactions !== undefined)
      clearTimeout(getters.integratedTransactions);
    getters.integratedTransactions = setTimeout(() => {
      store.dispatch("loadIntegratedTransactions");
      getters.integratedTransactions = undefined;
    }, 2000);
  });

  socket.on("integratedInventoryTransactionReport", () => {
    store.dispatch("loadLastIntegratedTransactionReport");
  });

  socket.on("preparationSlipProduct", () => {
    if (router.currentRoute.name === "PreparationSlipViewer") {
      store.dispatch("setPreparationSlipProductUpdateFlag", true);
    }
  });

  socket.on("recipes", () => {
    if (getters.recipes !== undefined) clearTimeout(getters.recipes);
    getters.recipes = setTimeout(() => {
      store.dispatch("loadRecipes");
      store.dispatch("loadProducts");
      getters.recipes = undefined;
    }, 2000);
  });

  socket.on("products", () => {
    if (getters.products !== undefined) clearTimeout(getters.products);
    getters.products = setTimeout(() => {
      store.dispatch("loadProducts");
      getters.products = undefined;
    }, 2000);
  });
}

function disconnect() {
  if (socket !== undefined) socket.disconnect();
  socket = undefined;
}

export { connect, disconnect, socket };
